module.exports = __webpack_public_path__ + "img/44.10.pH.800660d5.png";